import { ToastyService } from 'ng2-toasty';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DiscountService } from '../../Services/discount.service';


@Component({
  selector: 'app-member-discount-list',
  template: require('./member-discount-list.component.html'),
  styles: [require('./member-discount-list.component.css')]
})
export class MemberDiscountListComponent implements OnInit {

  discounts: any = [];
  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastyService: ToastyService,
    private discountService: DiscountService) {

    // route.params.subscribe(p => {
    //   if (p['id'])
    //     this.group.id = +p['id'];
    //   else
    //     this.group.id = 0;
    // });


  }

  ngOnInit() {
    this.discountService.getDiscounts().subscribe( x => {
      this.discounts = x ;
      // console.log(this.discounts);
    })
  }

  // submit() {
  //   if (this.group.id) {
  //     this.groupService.update(this.group).subscribe(x => {
  //       // console.log("save of group done: "+ x);
  //       this.router.navigate(['/groups/list']);
  //     });
  //   }
  //   else {
  //     this.groupService.create(this.group).subscribe(x => {
  //       // console.log(x);
  //       this.router.navigate(['/groups/list']);
  //     });
  //   }
  // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-discount-list/member-discount-list.component.ts